export const styles = {
  root: {
    display: "grid",
    placeItems: "center",
    height: "100vh",
  },
};
